import { render } from "./health-plans.vue?vue&type=template&id=2b8ac20c&scoped=true&ts=true"
import script from "./health-plans.vue?vue&type=script&lang=ts"
export * from "./health-plans.vue?vue&type=script&lang=ts"

import "./health-plans.vue?vue&type=style&index=0&id=2b8ac20c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8ac20c"]])

export default __exports__